<template>
  <div id="invest-modal">
    <div class="bg-light sticky-top w-100">
      <b-button
        variant="light"
        @click="$emit('closePanel', { closedBy: 'bg' })"
      >
        <close-icon />
      </b-button>
      <div class="wrap py-3 d-inline-block">
        <h6 class="mb-0">Farm at {{ subscription.location.locationname }}</h6>
      </div>
    </div>
    <div
      class="thumb bg-dark shadow-xl bg-cover text-white position-relative"
      style="height:130px;"
      :style="{
        backgroundImage: ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url('https://agbeloba-media.s3.amazonaws.com/057a2dc9-9714-40ad-8482-abf38fd629ca.jpg')`
      }"
    >
      <div class="wrap position-absolute bottom-0 p-4">
        <!-- <component :is="`${subscription.slug}-icon`" :size="40"></component> -->
        <h6 class="mb-0">{{ subscription.packagename }}</h6>
      </div>
    </div>
    <hr class="mt-0" />
    <div class="land-location">
      <div class="px-3 py-2">
        <h6>Crop to plant</h6>
        <b-form-group
          label-for="backdrop-variant p-20"
          :invalid-feedback="formErrors.service"
          :state="fieldState.service"
        >
          <b-form-select
            v-if="farmServices.data"
            id="backdrop-variant"
            v-model="form.service"
            @change="setAmount"
          >
            <b-form-select-option disabled value="null"
              >--Select a service--</b-form-select-option
            >
            <b-form-select-option
              v-for="service in farmServices.data"
              :key="service.id"
              :value="service"
            >
              {{ service.farmingname }}
            </b-form-select-option>
          </b-form-select>
          <div class="text-center" v-else>
            <b-spinner label="Small Spinner"></b-spinner>
          </div>
        </b-form-group>
        <div class="percent-interest mb-4" v-if="form.service">
          <h6>Percetage interest</h6>
          <p class="w-100 text-left" v-if="form.service">
            {{
              form.service
                ? `${form.service.minroi}% - ${form.service.maxroi}%`
                : `0%`
            }}

            <b-badge variant="primary">
              {{ form.service.farmingcycle ? form.service.farmingcycle : 0 }}
              month{{ form.service.farmingcycle === 1 ? "" : "s" }}
            </b-badge>
          </p>
        </div>

        <h6 v-if="form.service">Number Of Plots</h6>
        <b-form-group
          label-for="backdrop-variant"
          v-if="form.service"
          :invalid-feedback="formErrors.plots"
          :state="fieldState.plots"
        >
          <b-form-input
            id="reference"
            type="number"
            v-model="form.plots"
            style="font-weight: bold"
            @keydown="validateNoDecimals"
            @input="validateNoDecimalsOnPaste"
          ></b-form-input>
        </b-form-group>

        <b-row v-if="form.service">
          <b-col cols="5" class="mb-4">
            <div class="wrapper py-3">
              <small>Farming Cost</small>
              <h5 class="mb-0">{{ formatMoney(amountPaystack) }}</h5>
            </div>
          </b-col>
          <b-col cols="7" class="mb-4">
            <div class="wrapper p-3 bg-light dash-card">
              <small>Estimated returns</small>
              <h5 class="mb-0">{{ roi }}</h5>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-form @input="formInput">
      <b-col cols="12" v-if="form.service">
        <b-form-group label="Pay Via">
          <b-form-radio-group
            id="payment-source"
            :options="paymentOptions"
            v-model="paymentType"
            buttons
            button-variant="white"
            name="radio-btn-outline"
            class="w-100 custom-radio"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-collapse :visible="paymentType == 'card'" id="select-card-wrapper">
        <hr class="mt-0" />
        <b-col cols="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-append>
                <b-button
                  @click="openPaystack"
                  variant="primary"
                  :disabled="submittingPaystack || error || loading"
                  >{{ submittingPaystack ? "Paying" : "Pay Now" }}</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-collapse>
      <b-collapse :visible="paymentType == 'wallet'" id="select-card-wrapper">
        <hr class="mt-0" />
        <b-col cols="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-append>
                <b-button
                  @click="openPaystack"
                  variant="primary"
                  :disabled="submittingPaystack || error || loading"
                  >{{ submittingPaystack ? "Paying" : "Pay Now" }}</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-collapse>
      <b-collapse :visible="paymentType == 'bank'" id="select-card-wrapper">
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="wrapper bg-light dash-card p-3 mb-4">
                <h6>
                  Payment Details
                  <b-button
                    size="sm"
                    v-b-modal.getpaymentdetails
                    variant="primary"
                    class="my-2"
                    >How to pay</b-button
                  >
                </h6>
                <hr />
                <b-row>
                  <b-col cols="6">
                    <small>Account Name</small>
                  </b-col>
                  <b-col cols="6">Globarel Limited</b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col cols="6">
                    <small>Account Number</small>
                  </b-col>
                  <b-col cols="6">0251451096</b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col cols="6">
                    <small>Bank</small>
                  </b-col>
                  <b-col cols="6">Guarantee Trust Bank</b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Upload Payment Proof:"
            :invalid-feedback="formErrors.paymentproof"
            :state="fieldState.paymentproof"
          >
            <b-form-file
              required
              v-model="form.paymentproof"
              accept=".jpg, .jpeg, .png, .gif"
              id="paymentproof"
              ref
              :state="fieldState.paymentproof"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </b-form-group>
        </b-col>
        <hr />
        <b-col cols="12">
          <label for="state">
            <h6>Bank</h6>
          </label>
          <b-form-select
            id="bankcode"
            v-model="form.bankcode"
            :options="nigerianBanks"
            :state="fieldState.bankcode"
            required
            class="mb-4"
          >
            <template v-slot:first>
              <option :value="null" disabled>-- Select Your Bank --</option>
            </template>
          </b-form-select>
          <b-form-invalid-feedback :state="fieldState.bankcode">
            {{ formErrors.bankcode }}
          </b-form-invalid-feedback>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Payment Reference:"
            :invalid-feedback="formErrors.reference"
            :state="fieldState.reference"
          >
            <b-form-input
              id="reference"
              type="text"
              v-model="form.reference"
              :state="fieldState.reference"
              placeholder="e.g 100003333222"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            @click="submit"
            :disabled="submitting"
            variant="primary"
            class="mb-4"
            >Upload</b-button
          >
        </b-col>
      </b-collapse>
    </b-form>
    <div
      class="overlay-load position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
      style="top:0;left:0;z-index:10;background-color:rgba(255,255,255,0.7)"
      v-if="submittingPaystack || submitting"
    >
      <b-spinner label="Small Spinner"></b-spinner>
    </div>
    <paystack
      :amount="amountPaystack * 100"
      :email="userObj.email"
      :paystackkey="paystackKey"
      :callback="paystackCallback"
      :close="paystackClose"
      reference
      :embed="false"
    ></paystack>

    <b-modal
      centered
      title="Payment Bank Details"
      id="getpaymentdetails"
      ref="getpaymentdetails"
      ok-only
    >
      <div class="modal-wrap">
        <p class="mb-4">
          To invest using the bank deposit or transfer. You can make a deposit
          to the below stated bank account via bank/mobile banking transfer or
          bank deposit. Upload your payment evidence which could be a picture of
          stamped deposit slip or screenshot of the mobile transfer. Obtain your
          reference number from your bank
        </p>
        <b-row>
          <b-col cols="6">Account Name</b-col>
          <b-col cols="6">Globarel Limited</b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6">Account Number</b-col>
          <b-col cols="6">1020259225</b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="6">Bank</b-col>
          <b-col cols="6">United Bank for Africa</b-col>
        </b-row>
        <hr />
      </div>
    </b-modal>
  </div>
</template>

<script>
import paystack from "vue-paystack";
import { mapState } from "vuex";
import { TransactionService } from "@/services";
import { validateRequired, checkFormErrors } from "@/utils/validators";
import nigerianBanks from "@/utils/nigerianBanks";
import { formatMoney } from "@/utils/helpers";

export default {
  name: "ownership-siebar",
  props: {
    subscription: null
  },
  async mounted() {
    this.farmServices = await TransactionService.getFarmServices();
    this.getBG("crowd-funding");
    this.form.packageid = this.subscription.package.id;
  },
  data() {
    return {
      variant: "Maize",
      farmServices: [],
      form: {
        units: 0,
        reference: null,
        packageid: 0,
        paymentproof: null,
        bankcode: null,
        service: null,
        requesttype: "farm-for-me",
        plots: 0
      },
      packages: {},
      packagesROI: {},
      formErrors: {},
      paymentproof: null,
      paystackKey: process.env.VUE_APP_PAYSTACK_KEY,
      paymentType: null,
      paymentOptions: [
        { text: "Card", value: "card" },
        { text: "Wallet", value: "wallet" },
        { text: "Bank Transfer/ Deposit", value: "bank" }
      ],
      nigerianBanks: nigerianBanks,
      amountPaystack: 0,
      error: false,
      submitting: false,
      submittingPaystack: false,
      loading: false,
      errorLoading: false,
      progressUpload: 0,
      firebaseUploaded: null
    };
  },
  components: {
    paystack
  },
  computed: {
    ...mapState(["userObj"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    },
    roi() {
      if (!this.form.service) return formatMoney(0);
      const averagereturns =
        (this.form.service.minroi + this.form.service.maxroi) / 2;
      return formatMoney(
        this.amountPaystack + (this.amountPaystack * averagereturns) / 100
      );
    }
  },
  methods: {
    formatMoney,
    openPaystack(event) {
      event.preventDefault();
      if (this.form.plots < 1) {
        this.formErrors = { plots: "Please enter number of plots" };
        this.error = true;
        return;
      }
      if (!this.form.service) {
        this.formErrors = { service: "Please select a service" };
        this.error = true;
        return;
      }
      const btn = document.querySelector(".payButton");
      btn.click();
    },
    async paystackCallback(response) {
      const { reference } = response;

      this.submittingPaystack = true;
      try {
        const { message } = await TransactionService.verify({
          reference,
          id: this.form.packageid,
          requesttype: this.form.requesttype,
          subscriptionid: this.subscription.id,
          farmserviceid: this.form.service.id,
          units: this.form.plots
        });

        this.$store.dispatch("toast", {
          message
        });

        this.$emit("closePanel", true);

        /**setTimeout(() => {
          location.reload();
        }, 1000 * 1.5);**/
      } catch (err) {
        this.submittingPaystack = false;
      }
    },
    paystackClose() {},

    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        // this.processUpload();
        const { message } = await TransactionService.manualPayment({
          packageid: this.form.packageid,
          reference: this.form.reference,
          paymentproof: this.form.paymentproof,
          bankcode: this.form.bankcode,
          requesttype: "farm-for-me",
          farmserviceid: this.form.service.id,
          subscriptionid: this.subscription.id
        });

        this.$store.dispatch("toast", {
          message
        });
        this.$emit("closePanel", true);
      } catch (err) {
        this.error = true;
        this.formErrors = err;
      } finally {
        this.submitting = false;
      }
    },
    validateForm() {
      const { reference, packageid, paymentproof, bankcode } = this.form;
      let { errors, valid } = validateRequired({
        reference,
        packageid,
        paymentproof,
        bankcode
      });

      if (
        !errors.paymentproof &&
        paymentproof &&
        !["image/jpeg", "image/jpg", "image/png"].includes(
          this.form.paymentproof.type
        )
      ) {
        errors.paymentproof = "Only picture is allowed i.e jpeg, jpg, png";
        valid = false;
      }

      if (
        !errors.paymentproof &&
        paymentproof &&
        this.form.paymentproof.size > 20 * 1024 * 1024
      ) {
        errors.paymentproof = "File size is too large (20MB Maximum)";
        valid = false;
      }

      if (this.form.packageid == 0) {
        errors.packageid = "You need to select a package";
        valid = false;
      }

      if (valid === false) throw errors;
    },
    formInput(event) {
      if (event) {
        event.preventDefault();
      }
      this.error = false;
      this.formErrors = {};
    },
    validateNoDecimals(e) {
      if (!e) {
        return;
      }
      this.formInput();
      const key = e.key;

      // If is '.' key, stop it
      if (key === ".") return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === "e") return e.preventDefault();
    },
    validateNoDecimalsOnPaste() {
      // this.form.units = this.form.units.replace(/[^0-9]+/g, "");
      this.formInput();
      if (this.form.service)
        this.amountPaystack = this.form.service.amountperplot * this.form.plots;
    },
    setAmount() {
      this.formInput();
      if (this.form.service)
        this.amountPaystack = this.form.service.amountperplot * this.form.plots;
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    getBG(slug) {
      if (slug == "crowd-funding") {
        return (this.subscription.imageurl =
          "https://images.pexels.com/photos/681335/pexels-photo-681335.jpeg?auto=compress&cs=tinysrgb&h=650&w=940");
      } else {
        return "https://images.pexels.com/photos/87223/pexels-photo-87223.jpeg?auto=compress&cs=tinysrgb&h=650&w=940";
      }
    }
  }
};
</script>

<style scoped>
#sidebar-right {
  color: rgb(2, 2, 2) !important;
  background-color: #ffffff !important;
  width: 500px !important;
}

.sidebar-title {
  position: absolute;
  top: 12px;
  left: 45px;
}
.moneyTag {
  padding: 15px 10px;
  background: #ebebeb;
  font-size: 17px !important;
}
</style>
